var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.857,
    height: 20,
    viewBox: "0 0 22.857 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "printer-ic",
    d: "M8.285,3.856H19.714V6.713H8.285ZM24,8.142H4A1.433,1.433,0,0,0,2.571,9.57v7.143A1.433,1.433,0,0,0,4,18.142H8.285v5.714H19.714V18.142H24a1.433,1.433,0,0,0,1.429-1.429V9.57A1.433,1.433,0,0,0,24,8.142ZM5.428,12.428A1.429,1.429,0,1,1,6.856,11a1.429,1.429,0,0,1-1.429,1.429Zm12.857,10H9.714V15.285h8.572Z",
    transform: "translate(-2.571 -3.856)",
    fill: "#54585d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.af0fa7d9cc2b7fc3dad8a9ffe86899d5.svg";
export { ForwardRef as ReactComponent };